<template>
    <div>
        <div :class="optionClass" :key="fieldId(key)" v-for="(option, key) in options">
            <input
                    :data-element="checkDataElement(dataElement + '_field_' + key)"
                    type="radio"
                    :name="name"
                    :id="fieldId(key)"
                    :disabled="option.disabled"
                    @change="$emit('change', option.value)"
                    :checked="value === option.value"
            />
            <label :data-element="checkDataElement(dataElement + '_label_' + key)" :for="fieldId(key)">{{ option.title }}</label>
        </div>
    </div>
</template>

<script>
/* global Mango */
export default {
    name: "FieldRadioGroup",
    model: {
        prop: 'value',
        event: 'change'
    },
    props: {
        options: Array,
        dataElement: String,
        optionClass: [Object, Array, String],
        value: [String, Number, Boolean]
    },
    data() {
        return {
            name: 'radio_' + Math.round(Math.random() * 1e6)
        }
    },
    methods: {
        checkDataElement(id) {
            return Mango.checkDataElement(id);
        },
        fieldId(key) {
            return this.name + '_' + key;
        }
    }
}
</script>

<style scoped>

</style>